import { render, staticRenderFns } from "./IncidentStats.vue?vue&type=template&id=67f94702"
import script from "./IncidentStats.vue?vue&type=script&lang=js"
export * from "./IncidentStats.vue?vue&type=script&lang=js"
import style0 from "./IncidentStats.vue?vue&type=style&index=0&id=67f94702&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports